import { Circle, BoxProps, Icon } from '@wegroup/design-system';
import React from 'react';

interface Props {
  checked: boolean;
  error?: boolean;
}

const CompanyScanProgressCheckmark: React.FC<
  React.PropsWithChildren<Props>
> = ({ checked, error }) => {
  const commonProps: BoxProps = {
    h: '4',
    w: '4',
  };

  if (error)
    return (
      <Circle {...commonProps} bg="danger.main">
        <Icon
          name="GeneralStatusWarningExclamation"
          color="danger.light"
          boxSize={4}
        />
      </Circle>
    );

  if (checked)
    return (
      <Circle {...commonProps} bg="success.main">
        <Icon
          name="GeneralStatusSuccessCheckmark"
          color="success.light"
          boxSize={4}
        />
      </Circle>
    );

  return <Circle {...commonProps} border="1px" borderColor="primary.500" />;
};

export default CompanyScanProgressCheckmark;
